/**
 * @flow
 * @relayHash d0bd00270915a7aceda279d4daf896aa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleSpellCheckQueryVariables = {|
  id: string,
  text: string,
|};
export type ArticleSpellCheckQueryResponse = {|
  +spellCheck: {|
    +rawAnswer: string,
    +factChecking: ?string,
  |}
|};
export type ArticleSpellCheckQuery = {|
  variables: ArticleSpellCheckQueryVariables,
  response: ArticleSpellCheckQueryResponse,
|};
*/


/*
query ArticleSpellCheckQuery(
  $id: ID!
  $text: String!
) {
  spellCheck(id: $id, text: $text) {
    rawAnswer
    factChecking
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "text",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "spellCheck",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id",
        "type": "ID!"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text",
        "type": "String!"
      }
    ],
    "concreteType": "SpellCheckResult",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rawAnswer",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "factChecking",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ArticleSpellCheckQuery",
  "id": null,
  "text": "query ArticleSpellCheckQuery(\n  $id: ID!\n  $text: String!\n) {\n  spellCheck(id: $id, text: $text) {\n    rawAnswer\n    factChecking\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleSpellCheckQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleSpellCheckQuery",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '070e34b2fd1123516850b11908d6e09c';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleSpellCheckQuery.graphql.js